import { ArrowUpRight } from "lucide-react";

export const BCNEXT_URL = "https://www.bcnext.it/";

export const TopBar = () => (
  <a
    href={BCNEXT_URL}
    target="_blank"
    rel="noreferrer"
    data-testid="bcnext-topbar"
    className="group relative z-[60] block overflow-hidden bg-[#5E2A52] text-white"
  >
    <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-3 gap-y-1 px-5 py-2.5 text-center sm:px-10">
      <span className="text-[11px] uppercase tracking-[0.28em] text-white/60">
        Progetto realizzato da
      </span>
      <span className="font-display text-base font-semibold tracking-tight text-white">
        BC&nbsp;NEXT
      </span>
      <span className="hidden text-[11px] uppercase tracking-[0.18em] text-[#E0708A] sm:inline">
        IT Consulting &amp; Piattaforme Digitali
      </span>
      <span className="hidden items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/80 transition-colors duration-300 group-hover:text-[#E0708A] sm:inline-flex">
        bcnext.it
        <ArrowUpRight
          size={12}
          className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </span>
    </div>
  </a>
);
